export default {
  name: "PlayerLoading"
};